<template>
	<div id="password" class="container panel">
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head title="Password Lookup" subtitle="Password Security Portal"></dash-head>
				
				<div>
					<hr class="mt-3 mb-3">
					<form v-if="!hasResult" id="lookup-password-form" novalidate class="needs-validation" :class="{'was-validated':hasError}" v-on:submit.prevent="doLookup">

						<error :error="error"></error>

						<div class="form-row">
							<div class="col-sm-6">
								<div class="m-t pl-3 pr-3 form-group required">
									<label class="control-label required font-weight-bold" for="password">Password Text</label>
									<input id="password" class="form-control" placeholder="" v-model="passwordValue"/>
								</div>
							</div>
							<div class="col-sm-6">
							</div>
						</div>

						<div class="clearfix mt-1 mb-3">
							<div class="float-left ml-3">
							</div>
							<div class="float-right mr-3">
								<button type="submit" class="btn btn-outline-primary px-3">Lookup</button>
							</div>
						</div>
					</form>

					<div v-if="hasResult" class="row mt-3">
						<div class="col-md-12">
							<dl>
								<dt>Value</dt>
								<dd>{{passwordValue}}</dd>

								<dt>NTLM Hash</dt>
								<dd>{{result.ntlmHash}}</dd>

								<dt>SHA1 Hash</dt>
								<dd>{{result.sha1Hash}}</dd>

								<dt>Exists</dt>
								<dd>{{result.exists}}</dd>

								<dt v-if="result.exists">Count</dt>
								<dd v-if="result.exists">{{result.count}}</dd>
							</dl>
						</div>
					</div>

					<div v-if="hasResult" class="clearfix mt-1 mb-3">
						<div class="float-left ml-3">
						</div>
						<div class="float-right mr-3">
							<button type="submit" class="btn btn-outline-primary px-3" @click="reset">Lookup Another</button>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import Error from './Error'

	import store from '../state'
	import api from '../api'

	export default {
		name: 'PasswordPanel',
		components: {SideBar, DashHead, Error},
		data() {
			return {
				error: '',
				passwordValue: '',
				hasResult: false,
				hasError: false,
				result: {}
			}
		},
		methods: {
			isInRole(role) {
				if (!store.state.user || !store.state.user.roles) return;
				return store.state.user.roles.indexOf(role) > -1;
			},
			reset() {
				this.error = '';
				this.hasError = false;
				this.hasResult = false;
				this.result = {};
				this.passwordValue = '';
			},
			async doLookup() {
				this.error = '';
				this.hasError = false;

				if (!this.passwordValue) this.error = 'Please enter a password';	
				
				if (this.error) {
					this.hasError = true;
					return;
				}
				
				//Lookup company data
				var response = await api.get(`marketing/lookup/${encodeURI(this.passwordValue)}`);	

				if (response.statusText === "OK") {
					this.hasResult = true;
					this.result = response.data;			
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/PasswordPanel.vue